// Enums for structured dosage calculations

export enum AnimalType {
  DOG = 'dog',
  CAT = 'cat',
  CHICKEN = 'chicken',
  GOAT = 'goat',
  HORSE = 'horse',
  RABBIT = 'rabbit',
  SHEEP = 'sheep',
  PIG = 'pig',
  CATTLE = 'cattle'
}

export enum MedType {
  TOLTRAZURIL = 'toltrazuril',
  SULFADIMETHOXINE = 'sulfadimethoxine',
  FENBENDAZOLE = 'fenbendazole',
  OMEPRAZOLE = 'omeprazole',
  IVERMECTIN = 'ivermectin',
  ALBENDAZOLE = 'albendazole',
  METRONIDAZOLE = 'metronidazole',
  AMPROLIUM = 'amprolium',
  PONAZURIL = 'ponazuril',
  PYRANTEL = 'pyrantel',
  SULFAMETHOXINE = 'sulfamethoxine'
}

export enum IndicationType {
  TREATMENT = 'treatment',
  PREVENTION = 'prevention',
  PROPHYLAXIS = 'prophylaxis'
}

export enum RegimenType {
  SINGLE = 'single',
  MULTI = 'multi'
}

export enum WeightUnit {
  KG = 'kg',
  LBS = 'lbs',
  GRAMS = 'grams'
}

export enum DosageUnit {
  MG = 'mg',
  ML = 'ml',
  TABLETS = 'tablets',
  DROPS = 'drops'
}

// Core dosage regimen structure
export interface DosageRegimen {
  mgPerKgLoadingDose?: number;
  mgPerKgRegularDose: number;
  doseFrequencyHours: number;
  regimenType: RegimenType;
  regimenFrequency: number; // Total number of doses for multi-dose regimens
  withdrawalPeriodDays?: number;
  minWeightKg?: number;
  maxWeightKg?: number;
  contraindications?: string[];
  notes?: string;
}

// Medication information
export interface MedicationInfo {
  name: string;
  concentrationMgPerMl?: number;
  tabletStrengthMg?: number;
  commonFormulations: string[];
  warnings: string[];
  activeIngredient: string;
}

// Complete dosage data structure
export type DosageMap = {
  [key in AnimalType]?: {
    [key in MedType]?: {
      [key in IndicationType]?: DosageRegimen;
    };
  };
};

export type MedicationMap = {
  [key in MedType]: MedicationInfo;
};

// Calculation result
export interface DosageCalculation {
  animalType: AnimalType;
  medType: MedType;
  indicationType: IndicationType;
  weightKg: number;
  regimen: DosageRegimen;
  medication: MedicationInfo;

  // Calculated values
  loadingDoseMg?: number;
  regularDoseMg: number;
  loadingDoseMl?: number;
  regularDoseMl?: number;
  loadingDoseTablets?: number;
  regularDoseTablets?: number;

  // Schedule
  totalDoses: number;
  frequencyDescription: string;
  withdrawalDate?: Date;

  // Validation
  isValid: boolean;
  warnings: string[];
  errors: string[];
}